/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createStoneSet = /* GraphQL */ `mutation CreateStoneSet(
  $input: CreateStoneSetInput!
  $condition: ModelStoneSetConditionInput
) {
  createStoneSet(input: $input, condition: $condition) {
    id
    stones {
      nextToken
      startedAt
      __typename
    }
    title
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStoneSetMutationVariables,
  APITypes.CreateStoneSetMutation
>;
export const updateStoneSet = /* GraphQL */ `mutation UpdateStoneSet(
  $input: UpdateStoneSetInput!
  $condition: ModelStoneSetConditionInput
) {
  updateStoneSet(input: $input, condition: $condition) {
    id
    stones {
      nextToken
      startedAt
      __typename
    }
    title
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStoneSetMutationVariables,
  APITypes.UpdateStoneSetMutation
>;
export const deleteStoneSet = /* GraphQL */ `mutation DeleteStoneSet(
  $input: DeleteStoneSetInput!
  $condition: ModelStoneSetConditionInput
) {
  deleteStoneSet(input: $input, condition: $condition) {
    id
    stones {
      nextToken
      startedAt
      __typename
    }
    title
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStoneSetMutationVariables,
  APITypes.DeleteStoneSetMutation
>;
export const createStone = /* GraphQL */ `mutation CreateStone(
  $input: CreateStoneInput!
  $condition: ModelStoneConditionInput
) {
  createStone(input: $input, condition: $condition) {
    id
    setId
    name
    key
    color
    size
    shape
    variant
    img
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    stoneSetStonesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStoneMutationVariables,
  APITypes.CreateStoneMutation
>;
export const updateStone = /* GraphQL */ `mutation UpdateStone(
  $input: UpdateStoneInput!
  $condition: ModelStoneConditionInput
) {
  updateStone(input: $input, condition: $condition) {
    id
    setId
    name
    key
    color
    size
    shape
    variant
    img
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    stoneSetStonesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStoneMutationVariables,
  APITypes.UpdateStoneMutation
>;
export const deleteStone = /* GraphQL */ `mutation DeleteStone(
  $input: DeleteStoneInput!
  $condition: ModelStoneConditionInput
) {
  deleteStone(input: $input, condition: $condition) {
    id
    setId
    name
    key
    color
    size
    shape
    variant
    img
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    stoneSetStonesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStoneMutationVariables,
  APITypes.DeleteStoneMutation
>;
export const createGame = /* GraphQL */ `mutation CreateGame(
  $input: CreateGameInput!
  $condition: ModelGameConditionInput
) {
  createGame(input: $input, condition: $condition) {
    id
    owner
    sharedWith
    title
    description
    currentPlayer
    board {
      name
      key
      stone {
        name
        key
        color
        size
        shape
        variant
        img
        __typename
      }
      __typename
    }
    currentStone {
      name
      key
      color
      size
      shape
      variant
      img
      __typename
    }
    player1
    player2
    player1UserId
    player2UserId
    gameHasStarted
    expertMode
    winner
    winRow
    iconSet
    stoneSetId
    seriesId
    rejoinedPlayers
    rematchCreated
    rematchId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    gameSeriesGamesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGameMutationVariables,
  APITypes.CreateGameMutation
>;
export const updateGame = /* GraphQL */ `mutation UpdateGame(
  $input: UpdateGameInput!
  $condition: ModelGameConditionInput
) {
  updateGame(input: $input, condition: $condition) {
    id
    owner
    sharedWith
    title
    description
    currentPlayer
    board {
      name
      key
      stone {
        name
        key
        color
        size
        shape
        variant
        img
        __typename
      }
      __typename
    }
    currentStone {
      name
      key
      color
      size
      shape
      variant
      img
      __typename
    }
    player1
    player2
    player1UserId
    player2UserId
    gameHasStarted
    expertMode
    winner
    winRow
    iconSet
    stoneSetId
    seriesId
    rejoinedPlayers
    rematchCreated
    rematchId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    gameSeriesGamesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGameMutationVariables,
  APITypes.UpdateGameMutation
>;
export const deleteGame = /* GraphQL */ `mutation DeleteGame(
  $input: DeleteGameInput!
  $condition: ModelGameConditionInput
) {
  deleteGame(input: $input, condition: $condition) {
    id
    owner
    sharedWith
    title
    description
    currentPlayer
    board {
      name
      key
      stone {
        name
        key
        color
        size
        shape
        variant
        img
        __typename
      }
      __typename
    }
    currentStone {
      name
      key
      color
      size
      shape
      variant
      img
      __typename
    }
    player1
    player2
    player1UserId
    player2UserId
    gameHasStarted
    expertMode
    winner
    winRow
    iconSet
    stoneSetId
    seriesId
    rejoinedPlayers
    rematchCreated
    rematchId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    gameSeriesGamesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGameMutationVariables,
  APITypes.DeleteGameMutation
>;
export const createGameSeries = /* GraphQL */ `mutation CreateGameSeries(
  $input: CreateGameSeriesInput!
  $condition: ModelGameSeriesConditionInput
) {
  createGameSeries(input: $input, condition: $condition) {
    id
    games {
      nextToken
      startedAt
      __typename
    }
    gameIds
    title
    description
    player1
    player2
    player1Wins
    player2Wins
    playerQueue
    seriesMode
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGameSeriesMutationVariables,
  APITypes.CreateGameSeriesMutation
>;
export const updateGameSeries = /* GraphQL */ `mutation UpdateGameSeries(
  $input: UpdateGameSeriesInput!
  $condition: ModelGameSeriesConditionInput
) {
  updateGameSeries(input: $input, condition: $condition) {
    id
    games {
      nextToken
      startedAt
      __typename
    }
    gameIds
    title
    description
    player1
    player2
    player1Wins
    player2Wins
    playerQueue
    seriesMode
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGameSeriesMutationVariables,
  APITypes.UpdateGameSeriesMutation
>;
export const deleteGameSeries = /* GraphQL */ `mutation DeleteGameSeries(
  $input: DeleteGameSeriesInput!
  $condition: ModelGameSeriesConditionInput
) {
  deleteGameSeries(input: $input, condition: $condition) {
    id
    games {
      nextToken
      startedAt
      __typename
    }
    gameIds
    title
    description
    player1
    player2
    player1Wins
    player2Wins
    playerQueue
    seriesMode
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGameSeriesMutationVariables,
  APITypes.DeleteGameSeriesMutation
>;
export const createPlayerState = /* GraphQL */ `mutation CreatePlayerState(
  $input: CreatePlayerStateInput!
  $condition: ModelPlayerStateConditionInput
) {
  createPlayerState(input: $input, condition: $condition) {
    id
    gameList
    playerAssignments
    preferences
    dismissedClaims
    playerNickname
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlayerStateMutationVariables,
  APITypes.CreatePlayerStateMutation
>;
export const updatePlayerState = /* GraphQL */ `mutation UpdatePlayerState(
  $input: UpdatePlayerStateInput!
  $condition: ModelPlayerStateConditionInput
) {
  updatePlayerState(input: $input, condition: $condition) {
    id
    gameList
    playerAssignments
    preferences
    dismissedClaims
    playerNickname
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlayerStateMutationVariables,
  APITypes.UpdatePlayerStateMutation
>;
export const deletePlayerState = /* GraphQL */ `mutation DeletePlayerState(
  $input: DeletePlayerStateInput!
  $condition: ModelPlayerStateConditionInput
) {
  deletePlayerState(input: $input, condition: $condition) {
    id
    gameList
    playerAssignments
    preferences
    dismissedClaims
    playerNickname
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlayerStateMutationVariables,
  APITypes.DeletePlayerStateMutation
>;
